import { Controller } from "@hotwired/stimulus";

// 自动提交表单控件：监听元素内任意表单项变化，立刻提交所在 form。
// 用法：在 form 上加 data-controller="auto-submit" 即可。
export default class extends Controller {
  connect() {
    this.boundSubmit = () => this.submit();
    this.element.addEventListener("change", this.boundSubmit);
  }

  disconnect() {
    this.element.removeEventListener("change", this.boundSubmit);
  }

  submit() {
    this.element.requestSubmit();
  }
}
